export enum LogLevel {
	debug = 'debug',
	info = 'info',
	warn = 'warn',
	error = 'error',
}

export enum LoggerServices {
	PaymentService = 'payment-service',
	NetworkService = 'network-service',
	ChatService = 'chat-service',
	AudioPlayer = 'audio-player',
	UserService = 'user-service',
	BotService = 'bot-service',
	EmailConfirmation = 'email-confirmation',
	ImageLoader = 'image-loader',
	VideoLoader = 'video-loader',
	TestUserService = 'test-user-service',
	AgeConfirmation = 'age-confirmation',
	LocationService = 'location-service',
	SitemapService = 'sitemap-service',
	AnnalsService = 'annals-service',
	PublicBotApiService = 'public-bot-api-service',
	RetentionService = 'retention-service',
	Global = 'global',
	SanityService = 'sanity',
	MetricsService = 'metrics-service',
	GTMAnalytics = 'gtm-analytics',
	MySubscriptions = 'my-subscriptions',
}

export enum LoggerMessages {
	BuyNeuronsScreenOpened = 'buy-neurons-screen-opened',
	PaymentContextError = 'payment-context-error',
	PaywallContextError = 'paywall-context-error',
	CannotGetPaymentModalRef = 'payment-modal-ref-error',
	CannotCancelSubscription = 'subscription-cancel-error',

	NetworkRequestFailed = 'network-request-failed',
	WebsocketConnectionFailed = 'websocket-connection-failed',
	WebsocketParseFailed = 'websocket-parse-failed',

	AudioPlayerTriedToPlayAudioWithoutToken = 'audio-player-no-token',
	CannotDeleteMessage = 'cannot-delete-message',
	NoBotDataInMessageList = 'no-bot-data-in-message-list',

	ChatReviewContextError = 'chat-review-context-error',
	ChatReviewModalContextError = 'chat-review-modal-context-error',
	CannotPlayVideoAvatarInChat = 'chat-video-avatar-error',
	InitiateTopicsError = 'chat-topics-init-error',
	ResetMemoryError = 'chat-reset-memory-error',

	RenderMessageError = 'message-render-error',
	UserDeleteError = 'user-delete-error',
	AuthContextError = 'no-auth-context',
	InvalidBirthday = 'cannot-parse-bday',
	UserInfoUpdateError = 'cannot-update-user-info',

	EmailConfirmationError = 'email-confirmation-error',
	EmailConfirmationSentError = 'email-confirmation-sent-error',

	GenerateImageButtonClicked = 'image-generation-button-clicked',
	GenerateImageSuccessfullySent = 'image-generated-event-successfully-sent',
	ImageGeneratedEventReceived = 'image-generated-event-received',

	GenerateVideoButtonClicked = 'video-generation-button-clicked',
	GenerateVideoSuccessfullySent = 'video-generated-event-successfully-sent',
	VideoGeneratedEventReceived = 'video-generated-event-received',

	BotContextError = 'bot-context-error',

	EmptyMessageInChat = 'empty-message-in-chat',

	ImageLoadingTime = 'image-loading-time',
	ImageLoadingError = 'image-loading-error',
	VideoLoadingTime = 'video-loading-time',
	VideoMessageWithoutMediaId = 'video-message-wo-media-id',

	TestUserMessage = 'test-user-message',

	AgeConfirmationContextError = 'age-context-error',

	LocationRedirectError = 'location-redirect-error',

	SitemapError = 'sitemap-error',

	AnnalsSentEventError = 'annals-sent-event-error',
	AnnalsSentRegistrationEventError = 'annals-sent-registration-event-error',

	NoDataOnRetentionPopup = 'no-user-data-on-retention-popup',
	MetricLog = 'metric-log',
	MetricMarkersFailed = 'metric-markers-failed',
	MetricWebVitalsFailed = 'metric-web-vitals-failed',
	MetricGtmFailed = 'metric-gtm-failed',

	SanityInvalidPerspective = 'sanity-invalid-perspective',
	OrchestrationError = 'orchestration-error',

	Unknown = 'unknown-error',
}

export const SERVICE_NAME = 'eden';

export const LevelMap: Record<LogLevel, number> = {
	debug: 0,
	info: 1,
	warn: 2,
	error: 3,
};
